<template>
  <div class="introduction">
    <div class="introduction-container">
      <div class="introduction-container-title companyProfile_box">走进畅图科技</div>
      <div class="introduction-container-introduction companyProfile_box">About Changtu Technology
      </div>
      <!-- <div style="width: 50%;" v-html="dataInfo['rich-editor179f648a']"></div> -->
      <div style="width: 45%; ">
        <!-- <p class="introduction-container-content-jianjie companyProfile_box">
          畅图科技致力于打造领先的地学智能云产品与服务体系，围绕行业核心需求，以自主知识产权的畅图云产品为基础，融合多源异构业务数据，应用矿山综合大数据智能Ai服务，通过核心地学建模与零代码搭建技术快速构建行业应用，为用户提供综合高效的智能化服务能力。
        </p>
        <p class="introduction-container-content-jianjie companyProfile_box">
          畅图科技成立于2016年，总部位于北京，在河南、内蒙、新疆等地设有分支机构。公司团队由国内一流院校硕博组建而成，具备丰富的地矿、GIS、AI等技术经验。 </p>
        <p class="introduction-container-content-jianjie companyProfile_box">
          畅图科技依托优质科研资源，立足自主研发，以畅图云产品矩阵为基础，实施面向矿山、地质、监测、水利、轨道交通、市政、石油石化、园区等多个垂直行业的技术研发与产品推广。
         </p> -->
        <p class="introduction-container-content-jianjie companyProfile_box">{{ text2 }}</p>
        <p class="introduction-container-content-jianjie companyProfile_box">{{ text1 }}</p>
        <p class="introduction-container-content-jianjie companyProfile_box">{{ text }}</p>
      </div>

    </div>

  </div>
  <div class="introduction-mobile">
    <div class="introduction-mobile-title">走进畅图科技</div>
    <div class="introduction-container-mobile-introduction">About Changtu Technology</div>
    <div class="introduction-container-mobile-content">
      <div class="animate__animated animate__fadeInUp">
        <p class="introduction-container-content-jianjie companyProfile_box">{{ text2 }}</p>
        <p class="introduction-container-content-jianjie companyProfile_box">{{ text1 }}</p>
        <p class="introduction-container-content-jianjie companyProfile_box">{{ text }}</p>
      </div>
    </div>
    <learnmore path="about" :query="{ id: 'companyProfile' }"></learnmore>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import learnmore from "@/components/learnmore.vue"
import ScrollReveal from 'scrollreveal'
const dataInfo = ref(null)
const technical = ref(null)

const text2 = `北京畅图科技有限公司是一家专注矿山数字化底座产品研发与应用推广的高新技术企业，深耕矿山地质行业，为矿山数字化转型及智能化升级提供基础数字底座与技术服务。`

const text1 = `公司结合物联网、大数据、地学建模、人工智能等技术开展矿山行业智能应用开发与推广，公司依托优质科研资源，立足自主研发，经过多年项目积累，形成了矿山数字底座(MineBaseOS)为核心的产品矩阵。产品广泛应用于煤矿、金属矿、非金属矿等行业。`

const text = `先后荣获中关村高新技术企业、国家高新技术企业资格、科技型中小企业认证企业、北京市“创新型”中小企业、北京市“专精特新”中小企业、北京市双软认证企业、通过 ISO9001 质量管理体系认证、CMMI3 认证、ITSS 三级认证、企业信用 AAA 级等级认证、华为技术认证、鲲鹏技术认证、飞腾兼容认证，为中关村数字建筑绿色发展联盟会员企业、中国应急管理学会会员企业、启迪之星壹计划企业、中国城市科学研究会地下空间专业委员会会员企业，华为生态合作伙伴、中国移动协同创新基地合作伙伴、北京软件和信息服务业协会理事会会员单位、北京信息技术应用创新工作委员会会员单位，学院路校友科技创新赛事总决赛优胜项目，2023年度“CAS 概念验证计划”专项项目获得三等奖，拥有近30余项软件著作权及发明专利。公司致于矿山提供优质、可靠、高效的软件产品及解决方案。`


const getData = async () => {
  let params = {
    page: 1,
    pageSize: 10,
    worksheetId: "6805ab69ec5e343d1c98257e",
  }
  const res = await getFilterList(params)
  if (res.code === 200 && res.data && res.data.length > 0) {
    dataInfo.value = res.data[0]
  }
  let _params = {
    page: 1,
    pageSize: 10,
    worksheetId: "6805abb0ec5e343d1c982655",
    sortField: "number91f457d6",
    isAsc: true
  }
  const _res = await getFilterList(_params)
  if (_res.code === 200 && _res.data && _res.data.length > 0) {
    technical.value = _res.data
  }

}

onMounted(() => {
  // getData()
  const sr = ScrollReveal({
    distance: '50px',
    duration: 1000,
    delay: 300,
  })

  // 为每个元素配置不同的动画
  sr.reveal(".companyProfile_box", {
    beforeReveal: (el) => {
      el.classList.add('animate__fadeInUp')
    },
  })
})

</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
  .introduction {
    display: none !important;
  }

  .introduction-mobile {
    display: block;
  }
}



@media screen and (min-width: 800px) {
  .introduction {
    display: flex !important;
  }

  .introduction-mobile {
    display: none;
  }
}

.introduction {
  font-family: 'PuHuiTi';
  height: 650px;
  width: 100%;
  // display: flex;
  // justify-content: center;
  margin-top: 50px;
}

.introduction-container {
  background: url("../../../assets//image/map.png") no-repeat;
  background-position-x: 50%;
  height: 100%;
  width: 1620px;
  margin-left: 18%;
  margin-right: 18%;
}

.introduction-container-title {
  font-size: 48px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

}

.introduction-container-introduction {
  font-size: 20px;
  font-weight: 400;
  margin: 20px 0;
  color: rgba(153, 153, 153, 1);

}

.introduction-container-technical {
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 100px;
}

.introduction-container-technical-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.introduction-container-technical-item-num {
  font-size: 70px;
  font-weight: 400;
  color: rgba(32, 129, 235, 1);
}

.introduction-container-technical-item-title {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.introduction-container-content-jianjie {
  text-indent: 2em;
  letter-spacing: 2px;
  font-family: 'PuHuiTiRegular';
  line-height: 1.5;
}

.introduction-mobile {
  width: 100%;
  padding-bottom: 20px;

  font-family: 'PuHuiTi';
}

.introduction-mobile-title {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 40px;
  color: rgba(51, 51, 51, 1);
  margin-top: 60px;
}

.introduction-container-mobile-content {
  width: 100%;
  background: url("../../../assets/image/home/Introduction_bg.png");
  padding: 10px 20px 20px 20px;
}

.introduction-container-mobile-introduction {
  font-size: 20px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>